function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import project_service from '@/apps/chatbots/services/projects_services';
import domainService from '@/apps/data-platform/services/master_data/domain_service';
import indicator_services from '@/apps/chatbots/services/indicator_services';
import OrganizacionComponent from '@/components/OrganizacionComponent.vue';
import ChatMembers from './ChatMembers.vue';
import DateResources from './DateResources.vue';
import TimelineChart from './TimelineChart.vue';
export default {
  name: 'OrganizationIndicators',
  components: {
    OrganizacionComponent: OrganizacionComponent,
    ChatMembers: ChatMembers,
    DateResources: DateResources,
    TimelineChart: TimelineChart
  },
  data: function data() {
    var today = new Date();
    var startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    return {
      dateRange: [this.formatDate(startOfMonth), this.formatDate(today)],
      dateRangeRules: [],
      formattedDate: '',
      menu: false,
      selectedDomain: userInfo.domain,
      list_orgs: [],
      companyCode: '',
      selectedProject: '',
      projects: [],
      selectedMails: [],
      chatMembersKey: 0,
      isLoadingMails: false,
      isLoadingMessages: false,
      isLoadingSessions: false,
      isLoadingActivity: false,
      isReadyToLoadChatMembers: false,
      dataProject: {
        total_projects_dev: 0,
        total_projects_prod: 0,
        total_projects_prod_limit: 0,
        total_messages: 0,
        total_sessions: 0
      },
      default_config: {},
      dateRangeRequiredRule: function dateRangeRequiredRule(v) {
        return v && v.length === 2 && v[0] && v[1] || 'Debe seleccionar un rango de fechas';
      },
      rowClass: {
        'pl-0 pt-2': this.$vuetify.breakpoint.mdAndUp,
        'pl-0 pt-4': this.$vuetify.breakpoint.smAndDown
      }
    };
  },
  computed: {
    getClassMembers: function getClassMembers() {
      return 'col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12';
    },
    getClassResources: function getClassResources() {
      return 'col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12';
    },
    getClassConversations: function getClassConversations() {
      return 'col-md-12 col-sm-12';
    },
    getClassMetrics: function getClassMetrics() {
      return 'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12';
    }
  },
  created: function created() {
    this.getDefaultConfig();
    this.getListOrgsDetailed();
    this.listProjects();
    //this.setupUser();
    this.updateFormattedDate();
    this.loadGoogleCharts();
  },
  methods: {
    // eventos
    changeRangeDate: function changeRangeDate() {
      this.selectedProject = '';
      this.selectedDomain = userInfo.domain;
      this.resetChatMembers();
      this.reloadCharts();
    },
    changeDomain: function changeDomain() {
      this.selectedProject = '';
      this.listProjects();
      this.resetChatMembers();
      this.reloadCharts();
    },
    changeProject: function changeProject() {
      this.resetChatMembers();
      //console.log("changeProject",this.buildRequest())
      this.reloadCharts();
    },
    changeMails: function changeMails(selectedEmails) {
      this.selectedMails = selectedEmails;
      //console.log("changeProject",this.buildRequest())
      this.reloadCharts();
    },
    resetChatMembers: function resetChatMembers() {
      this.chatMembersKey++;
      this.selectedMails = [];
    },
    // 
    loadGoogleCharts: function loadGoogleCharts() {
      var _this = this;
      //if (typeof google !== 'undefined' && google.visualization) {
      //    this.reloadCharts();
      //    return;
      //}
      var script = document.createElement('script');
      script.src = 'https://www.gstatic.com/charts/loader.js';
      script.onload = function () {
        google.charts.load('current', {
          packages: ['corechart'],
          language: 'es'
        });
        google.charts.setOnLoadCallback(function () {
          _this.reloadCharts();
        });
      };
      document.head.appendChild(script);
    },
    reloadCharts: function reloadCharts() {
      if (!userInfo || !userInfo.orgs || typeof google === 'undefined' || !google.visualization) {
        console.warn('cargando...');
        setTimeout(this.reloadCharts, 100);
        return;
      }
      this.drawMessages(this.buildRequest());
      this.drawSessionsChart(this.buildRequest());
      this.drawActivityChart(this.buildRequest());
    },
    buildRequest: function buildRequest() {
      var _this2 = this;
      var _this$dateRange = _slicedToArray(this.dateRange, 2),
        start_date = _this$dateRange[0],
        end_date = _this$dateRange[1];
      var payload = {
        start_date: start_date,
        end_date: end_date
      };
      if (userInfo.userRoles.includes('ml_steward')) {
        //payload.user_id = userInfo.email; 
        if (this.selectedProject) payload.project_id = this.selectedProject;
        if (this.selectedMails.length > 0) payload.user_ids = this.selectedMails;
        if (this.list_orgs.length > 0) {
          this.companyCode = this.list_orgs.find(function (o) {
            return o.domain === _this2.selectedDomain;
          }).code;
        } else {
          this.companyCode = userInfo.orgs.find(function (O) {
            return O.domain === _this2.selectedDomain;
          }).code;
        }
        payload.company_code = this.companyCode;
      } else if (userInfo.userRoles.includes('ml_developer')) {
        payload.user_ids = [userInfo.email];
        this.companyCode = userInfo.orgs.find(function (O) {
          return O.domain === userInfo.domain;
        }).code;
        payload.company_code = this.companyCode;
      } else {
        payload.user_ids = [userInfo.email];
      }
      return payload;
    },
    drawSessionsChart: function drawSessionsChart(paramData) {
      var _this3 = this;
      this.isLoadingSessions = true;
      var container = this.$refs.sessionsChart;
      var chart = new google.visualization.LineChart(container);
      this.getSessions(paramData).then(function (activityData) {
        var data = new google.visualization.DataTable();
        data.addColumn('string', 'Fecha');
        data.addColumn('number', 'Abiertas');
        data.addColumn('number', 'Finalizadas');
        var rows = activityData.map(function (item) {
          var fechaStr = _this3.formatLocalDate(item.date);
          return [fechaStr, item.total_sesiones, item.sesiones_finalizadas];
        });
        data.addRows(rows);
        var view = new google.visualization.DataView(data);
        view.setColumns([0, 1, {
          calc: 'stringify',
          sourceColumn: 1,
          type: 'string',
          role: 'annotation'
        }, 2, {
          calc: 'stringify',
          sourceColumn: 2,
          type: 'string',
          role: 'annotation'
        }]);
        var options = {
          title: 'Sesiones por día',
          curveType: 'function',
          legend: {
            position: 'bottom'
          },
          backgroundColor: 'transparent',
          chartArea: {
            left: 40,
            top: 40,
            width: '100%',
            height: '70%'
          },
          hAxis: {
            title: 'Fecha',
            format: 'dd MMM',
            gridlines: {
              color: 'transparent'
            }
          },
          vAxis: {
            title: 'Cantidad',
            textPosition: 'none',
            gridlines: {
              color: 'transparent'
            },
            baselineColor: 'transparent'
          },
          height: 200
        };
        chart.draw(view, options);
        _this3.isLoadingSessions = false;
      });
    },
    drawActivityChart: function drawActivityChart(paramData) {
      var _this4 = this;
      this.isLoadingActivity = true;
      var container = this.$refs.activityChart;
      var chart = new google.visualization.ColumnChart(container);
      this.getActivityTime(paramData).then(function (activityData) {
        var data = new google.visualization.DataTable();
        data.addColumn('string', 'Fecha');
        data.addColumn('number', 'Horas');
        var rows = activityData.map(function (item) {
          var fechaStr = _this4.formatLocalDate(item.day);
          return [fechaStr, item.active_horas];
        });
        data.addRows(rows);
        var view = new google.visualization.DataView(data);
        view.setColumns([0, 1, {
          calc: 'stringify',
          sourceColumn: 1,
          type: 'string',
          role: 'annotation'
        }]);
        var options = {
          title: 'Horas de actividad por día',
          legend: {
            position: 'none'
          },
          backgroundColor: 'transparent',
          chartArea: {
            left: 40,
            top: 40,
            width: '100%',
            height: '70%'
          },
          hAxis: {
            title: 'Fecha',
            format: 'dd MMM',
            gridlines: {
              color: 'transparent'
            }
          },
          vAxis: {
            title: 'Horas',
            textPosition: 'none',
            gridlines: {
              color: 'transparent'
            },
            baselineColor: 'transparent'
          },
          height: 200
        };
        chart.draw(view, options);
        _this4.isLoadingActivity = false;
      });
    },
    drawMessages: function drawMessages(paramData) {
      var _this5 = this;
      this.isLoadingMessages = true;
      var container = this.$refs.messagesChart;
      var chart = new google.visualization.ColumnChart(container);
      this.getMessages(paramData).then(function (dataSet) {
        var data = new google.visualization.DataTable();
        data.addColumn('string', 'Fecha');
        data.addColumn('number', 'Mensajes');
        var rows = dataSet.map(function (item) {
          var fechaStr = _this5.formatLocalDate(item.date);
          return [fechaStr, item.total_mensajes];
        });
        data.addRows(rows);
        var view = new google.visualization.DataView(data);
        view.setColumns([0, 1, {
          calc: 'stringify',
          sourceColumn: 1,
          type: 'string',
          role: 'annotation'
        }]);
        var options = {
          title: 'Mensajes por día',
          legend: {
            position: 'none'
          },
          backgroundColor: 'transparent',
          chartArea: {
            left: 40,
            top: 40,
            width: '100%',
            height: '70%'
          },
          hAxis: {
            title: 'Fecha',
            format: 'dd MMM',
            gridlines: {
              color: 'transparent'
            }
          },
          vAxis: {
            title: 'Mensajes',
            textPosition: 'none',
            gridlines: {
              color: 'transparent'
            },
            baselineColor: 'transparent'
          },
          height: 450
        };
        chart.draw(view, options);
        _this5.isLoadingMessages = false;
      });
    },
    getActivityTime: function () {
      var _getActivityTime = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(paramData) {
        var response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return indicator_services.getActivityTime(paramData);
            case 1:
              response = _context.v;
              return _context.a(2, response.success ? response.data : []);
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error('Error obteniendo actividad:', _t);
              return _context.a(2, []);
          }
        }, _callee, null, [[0, 2]]);
      }));
      function getActivityTime(_x) {
        return _getActivityTime.apply(this, arguments);
      }
      return getActivityTime;
    }(),
    getSessions: function () {
      var _getSessions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(paramData) {
        var response, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return indicator_services.getSessions(paramData);
            case 1:
              response = _context2.v;
              this.dataProject.total_sessions = response.success ? response.data.reduce(function (sum, item) {
                return sum + item.total_sesiones;
              }, 0) : 0;
              return _context2.a(2, response.success ? response.data : []);
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.error('Error obteniendo sesiones', _t2);
              return _context2.a(2, []);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getSessions(_x2) {
        return _getSessions.apply(this, arguments);
      }
      return getSessions;
    }(),
    getMessages: function () {
      var _getMessages = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(paramData) {
        var response, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return indicator_services.getMessages(paramData);
            case 1:
              response = _context3.v;
              this.dataProject.total_messages = response.success ? response.data.reduce(function (sum, item) {
                return sum + item.total_mensajes;
              }, 0) : 0;
              return _context3.a(2, response.success ? response.data : []);
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.error('Error obteniendo mensajes', _t3);
              return _context3.a(2, []);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function getMessages(_x3) {
        return _getMessages.apply(this, arguments);
      }
      return getMessages;
    }(),
    listProjects: function () {
      var _listProjects = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this6 = this;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              project_service.getAll(this.selectedDomain).then(function (response) {
                if (response.success) {
                  _this6.projects = response.data;
                  _this6.dataProject.total_projects_dev = _this6.projects.filter(function (project) {
                    return project.env === "dev";
                  }).length;
                  _this6.dataProject.total_projects_prod = _this6.projects.filter(function (project) {
                    return project.env === "prod";
                  }).length;
                }
              });
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function listProjects() {
        return _listProjects.apply(this, arguments);
      }
      return listProjects;
    }(),
    getDefaultConfig: function () {
      var _getDefaultConfig = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _this7 = this;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              project_service.getDefaultConfig().then(function (response) {
                _this7.default_config = response.data;
                _this7.dataProject.total_projects_prod_limit = Number(_this7.default_config.limit);
              });
            case 1:
              return _context5.a(2);
          }
        }, _callee5);
      }));
      function getDefaultConfig() {
        return _getDefaultConfig.apply(this, arguments);
      }
      return getDefaultConfig;
    }(),
    getListOrgsDetailed: function () {
      var _getListOrgsDetailed = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _this8 = this;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              domainService.getOrganizationsDetail().then(function (response) {
                if (response.success) {
                  if (userInfo.domain == "intercorp.com.pe") {
                    _this8.list_orgs = response.data;
                  } else {
                    var orgs = _this8.default_config.orgs ? _this8.default_config.orgs : [];
                    if (!orgs.includes(userInfo.domain)) {
                      orgs.push(userInfo.domain);
                    }
                    _this8.list_orgs = response.data.filter(function (item) {
                      return orgs.includes(item.domain);
                    });
                  }
                }
              });
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      function getListOrgsDetailed() {
        return _getListOrgsDetailed.apply(this, arguments);
      }
      return getListOrgsDetailed;
    }(),
    // 
    formatDate: function formatDate(date) {
      return date.toISOString().substr(0, 10); // yyyy-MM-dd
    },
    updateFormattedDate: function updateFormattedDate() {
      if (this.dateRange[0] && this.dateRange[1]) {
        var startDate = new Date(this.dateRange[0]);
        var endDate = new Date(this.dateRange[1]);
        if (startDate > endDate) {
          var _ref = [this.dateRange[1], this.dateRange[0]];
          this.dateRange[0] = _ref[0];
          this.dateRange[1] = _ref[1];
        }
        this.formattedDate = "".concat(this.dateRange[0], " - ").concat(this.dateRange[1]);
        this.menu = false;

        // Eliminar reglas porque ya seleccionó rango
        this.dateRangeRules = [];
      } else {
        this.dateRangeRules = [this.dateRangeRequiredRule];
      }
    },
    formatLocalDate: function formatLocalDate(fechaIsoString) {
      var _fechaIsoString$split = fechaIsoString.split('-').map(Number),
        _fechaIsoString$split2 = _slicedToArray(_fechaIsoString$split, 3),
        year = _fechaIsoString$split2[0],
        month = _fechaIsoString$split2[1],
        day = _fechaIsoString$split2[2];
      var localDate = new Date(year, month - 1, day);
      return localDate.toLocaleDateString('es-PE', {
        day: '2-digit',
        month: 'short'
      });
    }
  }
};